import _ from "lodash";
import { useTranslation } from "react-i18next";
const milestones = require("../../src/data/milestones.json");

export const Section5 = () => {
  const milestonesData = _.cloneDeep(milestones);
  const { t } = useTranslation();

  return (
    <div className="w-screen h-full pb-10 md:pb-0 md:min-h-screen bg-milestone bg-white">
      <div className="section-container py-6 md:py-12">
        <div className="text-3xl font-bold mb-8">
          {t("Important Milestones")}
        </div>
        <div className="milestone-timeline" style={{ position: "relative" }}>
          {/* Continuous vertical line */}
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: 0,
              bottom: 0,
              width: "4px",
              background: "#222",
              transform: "translateX(-50%)",
              zIndex: 0,
            }}
          ></div>
          {milestonesData.map((milestones, idx) => {
            let isLeft = idx % 2 !== 0;
            return (
              <div key={`section5-${idx}`} className="milestone-row">
                {/* Left card (desktop) */}
                <div className="hidden md:flex w-1/2 justify-end">
                  {isLeft && (
                    <div className="milestone-card">
                      <div className="bg-[#3C3C3C] py-2 px-4 text-white rounded-t-lg w-full text-center mb-2">
                        {milestones.time}
                      </div>
                      <div className="text-lg xl:text-xl w-full py-2 text-center">
                        {t(milestones.title)}
                      </div>
                    </div>
                  )}
                </div>
                {/* Timeline dot */}
                <div
                  className="flex flex-col items-center relative"
                  style={{ zIndex: 2 }}
                >
                  <div className="milestone-dot">
                    <img src={`/assets/icon/${milestones.icon}`} alt="icon" />
                  </div>
                </div>
                {/* Right card (desktop) */}
                <div className="hidden md:flex w-1/2 justify-start">
                  {!isLeft && (
                    <div className="milestone-card">
                      <div className="bg-[#3C3C3C] py-2 px-4 text-white rounded-t-lg w-full text-center mb-2">
                        {milestones.time}
                      </div>
                      <div className="text-lg xl:text-xl w-full py-2 text-center">
                        {t(milestones.title)}
                      </div>
                    </div>
                  )}
                </div>
                {/* Mobile: always show below dot */}
                <div className="flex md:hidden w-full justify-center mt-4">
                  <div className="milestone-card">
                    <div className="bg-[#3C3C3C] py-2 px-4 text-white rounded-t-lg w-full text-center mb-2">
                      {milestones.time}
                    </div>
                    <div className="text-base w-full py-2 text-center">
                      {t(milestones.title)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
